var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.Search == 1) ? _c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.Search = '0'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus plus"
  }), _vm._v(" COD Remittance\n            ")]) : _vm._e(), _vm._v(" "), (_vm.Search == 0) ? _c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.Search = '1'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus minus"
  }), _vm._v(" COD Remittance\n            ")]) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    class: ("" + (_vm.Search == '0' ? 'show' : 'hide')),
    attrs: {
      "id": "collapse1",
      "visible": ""
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('b-form-fieldset', {
    staticClass: "col-12"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "searchview",
      "id": "searchview",
      "plain": true,
      "options": _vm.options
    },
    on: {
      "input": function($event) {
        _vm.changeRadio(_vm.selected)
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "opt"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0rem",
      "margin-bottom": "0rem"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Client Name "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.clientLoading
    },
    on: {
      "update:active": function($event) {
        _vm.clientLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "options": _vm.ClientAccountList,
      "name": "Client",
      "id": "Client",
      "placeholder": "Select Client",
      "label": "AccountName",
      "track-by": "AccountId",
      "data-ClientId": _vm.ClientId,
      "optionHeight": 100,
      "hide-selected": true
    },
    model: {
      value: (_vm.Client),
      callback: function($$v) {
        _vm.Client = $$v
      },
      expression: "Client"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "clienterr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-modal', {
    ref: "myModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Remittance Alert")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red",
      "line-height": "1.5 !important"
    }
  }, [_vm._v(_vm._s(_vm.ofd))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.modalShow = false
      }
    }
  }, [_vm._v("OK")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm datechecker",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header col-2"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Result\n                    "), (_vm.notApproved == 2 && _vm.resultCounts > 0) ? _c('span', {
    staticStyle: {
      "margin-left": "649%",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.exportDelivaryDate()
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    staticStyle: {
      "margin-top": "-22px"
    },
    attrs: {
      "type": "button"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export\n                    ")], 1)]) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.notApproved == 1) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables scrolltb",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listPendingRemittanceData), function(data, index) {
    return (_vm.resultCount > 0) ? _c('tr', {
      attrs: {
        "data-clientids": data.AccountId
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.pageno + index + 1))])]), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "type": "hidden",
        "name": _vm.setid('oldFromDate', data.AccountId),
        "id": _vm.setid('oldFromDate', data.AccountId)
      },
      model: {
        value: (_vm.form.oldFromDate[data.AccountId]),
        callback: function($$v) {
          _vm.$set(_vm.form.oldFromDate, data.AccountId, $$v)
        },
        expression: "form.oldFromDate[data.AccountId]"
      }
    }), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "data-fromids": 'fromids' + data.AccountId,
        "data-fromdates": data.FromDate,
        "left": "<i class='fa fa-calendar'></i>",
        "title": "Change From Date"
      }
    }, [_c('b-form-input', {
      staticClass: "form-control",
      attrs: {
        "data-fromdates": 'fromdates' + data.AccountId,
        "disabled": "",
        "type": "date",
        "name": _vm.setid('FromDate', data.AccountId),
        "id": _vm.setid('FromDate', data.AccountId)
      },
      on: {
        "change": function($event) {
          _vm.onChangeDate(_vm.form.FromDate[data.AccountId], _vm.form.toDate[data.AccountId], data.ClientId, data.AccountId, data.CompanyName, data.RemittanceType)
        }
      },
      model: {
        value: (_vm.form.FromDate[data.AccountId]),
        callback: function($$v) {
          _vm.$set(_vm.form.FromDate, data.AccountId, $$v)
        },
        expression: "form.FromDate[data.AccountId]"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "text-danger",
      attrs: {
        "id": _vm.setid('fdate', data.AccountId)
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-input-group', {
      attrs: {
        "data-toids": 'toids' + data.AccountId,
        "data-dates": data.ToDate,
        "left": "<i class='fa fa-calendar'></i>",
        "title": "Change To / Delivery Date"
      }
    }, [_c('b-form-input', {
      staticClass: "form-control",
      attrs: {
        "data-todates": 'todates' + data.AccountId,
        "type": "date",
        "name": _vm.setid('toDate', data.AccountId),
        "id": _vm.setid('toDate', data.AccountId)
      },
      on: {
        "change": function($event) {
          _vm.onChangeDate(_vm.form.FromDate[data.AccountId], _vm.form.toDate[data.AccountId], data.ClientId, data.AccountId, data.CompanyName, data.RemittanceType)
        }
      },
      model: {
        value: (_vm.form.toDate[data.AccountId]),
        callback: function($$v) {
          _vm.$set(_vm.form.toDate, data.AccountId, $$v)
        },
        expression: "form.toDate[data.AccountId]"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "text-danger",
      attrs: {
        "id": _vm.setid('tdate', data.AccountId)
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "data-comp": 'comp' + _vm.pageno + index + 1,
        "data-comps": 'comps' + data.AccountId,
        "data-compname": data.CompanyName
      }
    }, [_vm._v(_vm._s(data.CompanyName))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-remi": 'remi' + data.AccountId
      }
    }, [_vm._v(_vm._s(data.RemittanceType))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-ship": 'ship' + data.AccountId
      }
    }, [_vm._v(_vm._s(data.ShipmentCount))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-cod": 'cod' + data.AccountId
      }
    }, [_vm._v(_vm._s(data.CODAmount))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-foregi": 'foregi' + data.AccountId
      }
    }, [_vm._v(_vm._s(data.FreightAmount) + " ")]), _vm._v(" "), _c('td', [(data.ExceptionAWB.length > 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      attrs: {
        "data-excep": 'excep' + data.AccountId
      },
      on: {
        "click": function($event) {
          _vm.showReasonAWBNo(data.ExceptionAWB)
        }
      }
    }, [_vm._v(_vm._s(data.ExceptionAmount))]) : _vm._e(), _vm._v(" "), (data.ExceptionAWB.length <= 0) ? _c('span', [_vm._v(_vm._s(data.ExceptionAmount))]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "data-pay": 'pay' + data.AccountId
      }
    }, [_vm._v(_vm._s(data.PayableAmount))]), _vm._v(" "), _c('td', [(data.RemittanceType == 'Hybrid' && _vm.selected == 'AdHoc') ? _c('button', {
      staticClass: "btn btn-sm btn-success",
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.enableResponse = true;
          _vm.editFreightAmount(data.FromDate, data.ToDate, data.ClientId, data.AccountId, data.CompanyName);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit")]) : _vm._e(), _vm._v(" "), (_vm.recordType == 'tatoverdue' && data.PayableAmount > 0 && data.IsActive) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-remittbtn": 'remittbtn' + data.AccountId,
        "title": "Remit Client"
      },
      on: {
        "click": function($event) {
          _vm.onRemittance(_vm.form.FromDate[data.AccountId], _vm.form.toDate[data.AccountId], data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-dot-circle-o"
    }), _vm._v(" Remit")]) : _vm._e(), _vm._v(" "), (_vm.recordType == 'adhoc' && data.PayableAmount > 0 && data.IsActive) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-remittbtn": 'remittbtn' + data.AccountId,
        "title": "Remit Client"
      },
      on: {
        "click": function($event) {
          _vm.onAdHoctance(_vm.form.FromDate[data.AccountId], _vm.form.toDate[data.AccountId], data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-dot-circle-o"
    }), _vm._v(" Remit")]) : _vm._e(), _vm._v(" "), (data.PayableAmount > 0) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "data-remittbtn": 'remittbtn' + data.AccountId,
        "title": "Download Remittance Report",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.exportData(data.FromDate, data.ClientId, data.AccountId, data.CompanyName)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e()])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.notApproved == 1 && _vm.resultCount > 0) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.notApproved == 1 && _vm.resultCount > 1) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 3,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationManulaData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notApproved == 2) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables ",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.resultCounts == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listPendingRemittanceDatas), function(data, index) {
    return (_vm.resultCounts > 0) ? _c('tr', {
      attrs: {
        "data-clientids": data.ClientId
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.pageno + index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CompanyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.RemittanceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientremittedid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Cycle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipmentCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CODAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.FreightAmount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.ExceptionAmount > 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showReasonAWBNo(data.ExceptionAWB)
        }
      }
    }, [_vm._v(_vm._s(data.ExceptionAmount))]) : _vm._e(), _vm._v(" "), (data.ExceptionAmount <= 0) ? _c('span', [_vm._v(_vm._s(data.ExceptionAmount))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.PaidAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format_date(data.transactiondate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.UTRNo !== '') ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline"
      },
      attrs: {
        "title": "Update URT"
      },
      on: {
        "click": function($event) {
          _vm.PopUp(data)
        }
      }
    }, [_vm._v(_vm._s(data.UTRNo))]) : _vm._e(), _vm._v(" "), (data.UTRNo == '') ? _c('label', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "16px",
        "font-weight": "500"
      },
      attrs: {
        "title": "Add URT"
      },
      on: {
        "click": function($event) {
          _vm.PopUp(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle"
    })]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btns",
      staticStyle: {
        "margin-left": "6px",
        "background-color": "rgb(248, 6, 6)"
      },
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteRemittance(data.AccountId, data.clientremittedid, data.transactiondate, data.ShipmentCount)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.notApproved == 2 && _vm.resultCounts > 0) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.notApproved == 2 && _vm.resultCounts > 1) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 3,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationDelivaryData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "size": "vsm",
      "id": "bv-modal-example",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.enableResponse),
      callback: function($$v) {
        _vm.enableResponse = $$v
      },
      expression: "enableResponse"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableResponse),
      expression: "enableResponse"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-12"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('label', [_vm._v("Freight Amount")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.freightamnt),
      expression: "freightamnt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('freightamnt')
    },
    attrs: {
      "type": "number",
      "id": "freightamnt",
      "min": "0",
      "name": "freightamnt",
      "placeholder": "Enter Freight Amount"
    },
    domProps: {
      "value": (_vm.freightamnt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.freightamnt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm mt-4",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.updateFreightAmount();
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm mt-4",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.resetFreight();
      }
    }
  }, [_vm._v("Reset")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm mt-4",
    staticStyle: {
      "margin-left": "200px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "id": "closePop"
    },
    on: {
      "click": function($event) {
        _vm.enableResponse = false;
      }
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myClosureModalRef",
    on: {
      "ok": function($event) {
        _vm.FCModal = false
      }
    },
    model: {
      value: (_vm.FCModal),
      callback: function($$v) {
        _vm.FCModal = $$v
      },
      expression: "FCModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('form', {
    attrs: {
      "id": "FCform"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onUpdate('abc')
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("UTR Details "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utrno),
      expression: "utrno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "id": "utrno",
      "name": "utrno",
      "placeholder": "Enter UTR Number"
    },
    domProps: {
      "value": (_vm.utrno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.utrno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "utrnoerr"
    }
  }, [_vm._v("UTR number is required. ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rolefooter form-actions"
  }, [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")])], 1)])])], 1)])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myReasonModalRef",
    attrs: {
      "id": "#confirmationmodal2",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ReasonModalShow),
      callback: function($$v) {
        _vm.ReasonModalShow = $$v
      },
      expression: "ReasonModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("AWB No/Amount")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])]), _vm._v(" "), _c('tbody', [(_vm.DisputeArr.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(val.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(val.Amount))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "1%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.totalSum))])])])], 2)])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myConfModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.confModalShow),
      callback: function($$v) {
        _vm.confModalShow = $$v
      },
      expression: "confModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "15px",
      "padding": "10px",
      "color": "red"
    }
  }, [_vm._v("Are you sure?, you want to remit this record.")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideConfModal('0')
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "background-color": "#f86c6b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideConfModal('1')
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("From Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("To / Delivery Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Remittance Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Count")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("COD Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Freight Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Exception Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Payable Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Company Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Remittance Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Remittance Id")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Cycle")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Count")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("COD Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Freight Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Exception Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Paid Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Transaction"), _c('br'), _vm._v(" Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("UTR #")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bedc3d02","hasScoped":true}!./src/views/components/ManualRemittance/ManualRemittance.component.html
// module id = 628
// module chunks = 1